<script>
	export let position = 'outer';
</script>

<div id="wrapper" class:position_inner={position === 'inner'}>
	<div class="profile-main-loader">
		<div class="loader">
			<svg class="circular-loader"viewBox="25 25 50 50" >
				<circle class="loader-path" cx="50" cy="50" r="20" fill="none"
						stroke="var(--burgeins-green-1)"
						stroke-width="2" />
			</svg>
		</div>
	</div>
</div>


<style lang="scss">
	@import "../style/variables";

	#wrapper{
		position: absolute;
		height: 100%;
		width: 100%;
		left: 0;
		top: 0;

		&.position_inner {
			position: relative;
			display: contents;

			.profile-main-loader {
				transform: translateY(-50%);
			}
		}
	}

	.profile-main-loader {
		left: 50% !important;
		margin-left:-6.25em;
		position: absolute !important;
		top: 50% !important;
		margin-top: -6.25em;
		width: 2.8em;
		z-index: 9000 !important;
	}

	.profile-main-loader .loader {
		position: relative;
		margin: 0 auto;
		width: 12.5em;
		height: 12.5em;
	}
	.profile-main-loader .loader:before {
		content: '';
		display: block;
		padding-top: 100%;
	}

	.circular-loader {
		-webkit-animation: rotate 2s linear infinite;
		animation: rotate 2s linear infinite;
		height: 100%;
		-webkit-transform-origin: center center;
		-ms-transform-origin: center center;
		transform-origin: center center;
		width: 100%;
		position: absolute;
		top: 0;
		left: 0;
		margin: auto;
	}

	.loader-path {
		stroke-dasharray: 150,200;
		stroke-dashoffset: -10;
		-webkit-animation: dash 1.5s ease-in-out infinite, color 6s ease-in-out infinite;
		animation: dash 1.5s ease-in-out infinite, color 6s ease-in-out infinite;
		stroke-linecap: round;
	}

	@-webkit-keyframes rotate {
		100% {
			-webkit-transform: rotate(360deg);
			transform: rotate(360deg);
		}
	}

	@keyframes rotate {
		100% {
			-webkit-transform: rotate(360deg);
			transform: rotate(360deg);
		}
	}
	@-webkit-keyframes dash {
		0% {
			stroke-dasharray: 1,200;
			stroke-dashoffset: 0;
		}
		50% {
			stroke-dasharray: 89,200;
			stroke-dashoffset: -35;
		}
		100% {
			stroke-dasharray: 89,200;
			stroke-dashoffset: -124;
		}
	}
	@keyframes dash {
		0% {
			stroke-dasharray: 1,200;
			stroke-dashoffset: 0;
		}
		50% {
			stroke-dasharray: 89,200;
			stroke-dashoffset: -35;
		}
		100% {
			stroke-dasharray: 89,200;
			stroke-dashoffset: -124;
		}
	}


	@-webkit-keyframes color {
		0% {
			stroke: $color-burgeins-1;
		}
		40% {
			stroke: $color-burgeins-1;
		}
		66% {
			stroke: $color-burgeins-1;
		}
		80%, 90% {
			stroke: $color-burgeins-1;
		}
	}
	@keyframes color {
		0% {
			stroke: $color-burgeins-1;
		}
		40% {
			stroke: $color-burgeins-1;
		}
		66% {
			stroke: $color-burgeins-1;
		}
		80%, 90% {
			stroke: $color-burgeins-1;
		}
	}

</style>
